import { render, staticRenderFns } from "./SNSModal.vue?vue&type=template&id=445b03cc&scoped=true"
import script from "./SNSModal.vue?vue&type=script&lang=js"
export * from "./SNSModal.vue?vue&type=script&lang=js"
import style0 from "./SNSModal.vue?vue&type=style&index=0&id=445b03cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "445b03cc",
  null
  
)

export default component.exports